// Token vault. The creator's GitHub + Cloudflare tokens are secrets;
// per 08_AUTHORING_APP.md they live in localStorage (browser-only, the
// app has no server to hold them). Namespaced per Google subject id so
// switching identities on a shared machine doesn't leak tokens across
// accounts.
//
// This is intentionally thin — localStorage is the store of record.
// We do NOT sync these to git (they'd land in a repo) and we never
// transmit them to any BKA-operated endpoint; all token use is
// browser → GitHub/Cloudflare directly.

type SecretKind = "github_token" | "cf_token";

function key(kind: SecretKind, googleSub: string): string {
  return `bka/secret/${kind}/${googleSub}`;
}

export function getSecret(kind: SecretKind, googleSub: string): string | null {
  if (typeof localStorage === "undefined") return null;
  try {
    return localStorage.getItem(key(kind, googleSub));
  } catch {
    return null;
  }
}

export function setSecret(kind: SecretKind, googleSub: string, value: string): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(key(kind, googleSub), value);
  } catch (e) {
    console.warn(`[secrets] failed to persist ${kind}:`, e);
  }
}

export function clearSecret(kind: SecretKind, googleSub: string): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.removeItem(key(kind, googleSub));
  } catch { /* ignore */ }
}
